import React, { useEffect, useState } from 'react'
import Container from '../../../v2/Container'
import Image from '../../../Image'
import landingPageImg from '../../../../assets/purchase-yearbooks-landing-page.jpg'
import useQueryString from '../../../../hooks/use-query-string'
import { Package, Price, Student } from '../../../../models'
import Fetching from './Fetching'
import ErrorState from './ErrorState'
import YearbookForm from './YearbookForm'
import useLocalStorage from '../../../../hooks/useLocalStorage';
import Typography from '../../../Typography';
import StudentPromoImage from './StudentPromoImage';
import usePastImages from '../../../../hooks/usePastImages';
import { useCustomer } from '../../../../contexts/CustomerContext';
import routes from '../../../../routes';

const ERROR = 'ERROR'
const DONE = 'DONE'
const FETCHING = 'FETCHING'
const TOO_MANY_RESULTS = 'TOO_MANY_RESULTS'

export const useStudent = (params) => {
  const [student, setStudent] = useState()
  const [status, setStatus] = useState(FETCHING)

  useEffect(() => {
    setStatus(FETCHING)

    Student
      .includes('school')
      .where({ ...params })
      .extraParams({ yba: true })
      .all()
      .then((res) => {
        if (res.data.length === 1) {
          setStudent(res.data[0])
          setStatus(DONE)
        } else {
          setStudent(res.data[res.data.length - 1])
          setStatus(DONE)
        }
      })
      .catch(() => {
        setStatus(ERROR)
      })
  }, [params.studentId, params.schoolId])

  return { student, status }
}

export const useYearbookPackage = (schoolId, campaign) => {
  const [yearbook, setYearbook] = useState();
  const [yearbooks, setYearbooks] = useState([])
  const [status, setStatus] = useState(FETCHING)

  useEffect(() => {
    if (!schoolId) return

    const priceScope = Price.where({ for_school: schoolId })

    Package
      .includes({ options: { prices: 'school' } })
      .merge({ prices: priceScope })
      .where({ schoolId })
      .where({ has_prices_for_school: schoolId })
      .where({ name: { match: 'yearbook' } })
      .all()
      .then((res) => {
        //console.log(res.data[0]);
        //console.log(res.data[1]);
        if (res.data.length < 1) return

        //let sorted = res.data.sort((a, b) => a.options[0].prices[0].price - b.options[0].prices[0].price);

        if (campaign) {
          //sorted = res.data.sort((a, b) => b.campaign.includes(campaign) - a.campaign.includes(campaign));
        }

        setYearbooks(res.data)
        setYearbook(res.data[0])
      })
  }, [schoolId])

  return { yearbook, yearbooks, status }
}

const Yearbooks = () => {
  const { sch: schoolId, sid: studentId, campaign, message_id: messageId } = useQueryString()
  const { student, status } = useStudent({ schoolId, studentId })
  const { yearbook, yearbooks } = useYearbookPackage(schoolId, campaign)
  const [_, setIsUsingAccessCode] = useLocalStorage('isUsingAccessCode')
  const { customer, setCustomer } = useCustomer();

  useEffect(() => {
    if (!student?.email) return;

    setCustomer({ ...customer, email: student.email });
  }, [student]);

  const { data: pastImages } = usePastImages({ studentId: student?.id });

  setIsUsingAccessCode(true)

  if (status === FETCHING) return <Fetching />
  if (status === TOO_MANY_RESULTS || status === ERROR) {
    return <ErrorState message="We were unable to find your student. Please check back again later." />
  }

  if (!(student && yearbook)) {
    return (
      <Typography align="center" fontStyle="italic">
        The deadline to order yearbooks for this year has passed.  Yearbooks are no longer available.
      </Typography>
    )
  }

  return (
    <Container maxWidth="md">
      <StudentPromoImage campaign={campaign || yearbook.campaign} studentId={student.id} />
      <YearbookForm
        student={student}
        school={student.school}
        defaultYearbook={yearbook}
        yearbooks={yearbooks}
        messageId={messageId}
      />
    </Container>
  )
}

export default Yearbooks
